var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { warn } from '@ember/debug';
import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';
/**
 * @export
 * @class ToastService
 * @extends {Service}
 */
let ToastService = (_class = class ToastService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "content", _descriptor, this);
  }
  /**
   * Creates and returns a new toast notification.
   * @param {string} message content to display
   * @param {'error' | 'information' | 'success' | 'warning'} type type of toast notification
   * @returns {EmberObject | void}
   */
  addNotification({
    message,
    type
  }) {
    const isToastValid = Boolean(message);
    warn('Message mandatory attribute is missing', isToastValid, {
      id: 'pix-ui.toast.not-message'
    });
    if (!isToastValid) return;
    const toast = {
      message,
      type: type || 'success'
    };
    if (this.exists(toast)) {
      this.removeNotification(toast);
    }
    this.content = [...this.content, toast];
    return toast;
  }

  /**
   * Check if toast already exist in content array
   * @param {{message: string, type: string}} toast
   * @returns {boolean}
   */
  exists(toast) {
    return Boolean(this.content.find(value => toast.message === value.message && toast.type === value.type));
  }

  /**
   * Creates and returns a new error toast notification.
   * @param{string} message content to display
   * @returns {EmberObject | void}
   */
  sendErrorNotification({
    message
  }) {
    return this.addNotification({
      message,
      type: 'error'
    });
  }

  /**
   * Creates and returns a new success toast notification.
   * @param {string} message content to display
   * @returns {EmberObject | void}
   */
  sendSuccessNotification({
    message
  }) {
    return this.addNotification({
      message,
      type: 'success'
    });
  }

  /**
   * Creates and returns a new information toast notification.
   * @param {string} message content to display
   * @returns {EmberObject | void}
   */
  sendInformationNotification({
    message
  }) {
    return this.addNotification({
      message,
      type: 'information'
    });
  }

  /**
   * Creates and returns a new warning toast notification.
   * @param {string} message content to display
   * @returns {EmberObject | void}
   */
  sendWarningNotification({
    message
  }) {
    return this.addNotification({
      message,
      type: 'warning'
    });
  }

  /**
   * Remove toast notification from content list
   * @param {{message: string, type: string}} toast toast to remove
   * @returns {void}
   */
  removeNotification(toast) {
    if (!toast) return;
    this.content = this.content.filter(value => toast.message !== value.message || toast.type !== value.type);
  }

  /**
   * Remove all toast notification from content list
   * @param {void}
   * @returns {void}
   */
  removeAllNotifications() {
    if (this.content.length === 0) return;
    this.content = [];
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "content", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _class);
export { ToastService as default };